/** The chart colours as CSS variables (--series-1 blue, --series-2 orange, --series-3 aqua, --series-4 yellow), stepped for light and dark */
export const CHART_VARS = {
  '--series-1': '#2a78d6',
  '--series-2': '#eb6834',
  '--series-3': '#1baf7a',
  '--series-4': '#eda100',
  '[data-dark] &': {
    '--series-1': '#3987e5',
    '--series-2': '#d95926',
    '--series-3': '#199e70',
    '--series-4': '#c98500',
  },
};
